import config from '@/config'
export default [

  {
    title: "基础组件",
    type: "base",
    modules: [
      {
        icon: "FundOutlined",
        name: "轮播图",
        type: 'banner',
        selectType: 'drag',
        defaultData: {
          type: 'banner',
          name: '图片轮播',
          data: [
            { imgUrl: '', linkUrl: "", key: '' },
          ],
          params: {
            interval: "2800"
          }
        }
      },
      {
        icon: "WindowsOutlined",
        name: "图片橱窗",
        type: 'windows',
        selectType: 'drag',
        defaultData: {
          type: 'windows',
          name: '图片橱窗',
          data: [
            { imgUrl: "", linkUrl: "", key: '' },
            { imgUrl: "", linkUrl: "", key: "" },
          ],
          params: {
            interval: "2800"
          },
          style: {
            class: 'half',
            backgroundColor: "#ffffff",
            paddingTB: 0,
            paddingLR: 0,
          }
        }
      },
      {
        icon: "VideoCameraOutlined",
        name: "视频组件",
        type: 'videoModule',
        selectType: 'click',
        defaultData: {
          type: 'videoModule',
          name: '视频组件',
          params: {
            video_source: '',
            video_cover: '',
            autoplay: false,
            loop: false,
            muted: true,
            controls: true,
          },
          style: {
            height: 200,
            radius: 8,
          }
        }
      },
      {
        icon: "ColumnHeightOutlined",
        name: "空白条",
        selectType: 'drag',
        type: 'blank',
        defaultData: {
          type: 'blank',
          name: '空白条',
          params: {},
          style: {
            height: '20'
          }
        }
      }
    ],
  },
  {
    title: "业务组件",
    type: "profession",
    modules: [
      {
        icon: "AppstoreOutlined",
        name: "导航",
        type: 'nav',
        selectType: 'drag',
        defaultData: {
          type: 'nav',
          name: '导航',
          data: [
            { imgUrl: config.oss[process.env.VUE_APP_type] + 'web_base_assets/scan/report.png',def:config.oss[process.env.VUE_APP_type] + 'web_base_assets/scan/report.png', linkUrl: "examine", name: '检验报告', key: 'examine', config: { data: [] } },
            {
              imgUrl: config.oss[process.env.VUE_APP_type] + 'web_base_assets/scan/group.png',def: config.oss[process.env.VUE_APP_type] + 'web_base_assets/scan/group.png', linkUrl: "group", name: '粉丝社群', key: 'group', config: {
                icon: config.oss[process.env.VUE_APP_type] + 'web_base_assets/scan/group_icon.png',
                image: config.oss[process.env.VUE_APP_type] + 'web_base_assets/scan/group_bg.png'
              }
            },
            {
              imgUrl: config.oss[process.env.VUE_APP_type] + 'web_base_assets/scan/video.png',def:config.oss[process.env.VUE_APP_type] + 'web_base_assets/scan/video.png', linkUrl: "video", name: '宣传视频', key: 'video', defalut: config.oss[process.env.VUE_APP_type] + 'web_base_assets/scan/video.png', config: {
                video_cover: "",
                video_source: ''
              }
            },
            {
              imgUrl: config.oss[process.env.VUE_APP_type] + 'web_base_assets/scan/report.png',def:config.oss[process.env.VUE_APP_type] + 'web_base_assets/scan/report.png', linkUrl: "public", name: '公众号', key: 'public', config: {
                image: config.oss[process.env.VUE_APP_type] + 'web_base_assets/scan/group_bg.png'
              }
            },
          ],
          params: {
            interval: "2800"
          },
          style: {
            btnColor: "#ffffff",
            btnShape: "round"
          }
        }
      }, {
        icon: "AppstoreOutlined",
        name: "菜单",
        type: 'bottomNav',
        selectType: 'drag',
        defaultData: {
          type: 'bottomNav',
          name: '菜单',
          data: [
            { imgUrl: config.oss[process.env.VUE_APP_type] + 'web_base_assets/scan/query_icon.png',def: config.oss[process.env.VUE_APP_type] + 'web_base_assets/scan/query_icon.png', linkUrl: "query", name: '防伪查询', key: 'query', config: {} },
            { imgUrl: config.oss[process.env.VUE_APP_type] + 'web_base_assets/scan/center_icon.png',def:config.oss[process.env.VUE_APP_type] + 'web_base_assets/scan/center_icon.png', linkUrl: "center", name: '会员中心', key: 'center', config: {} },
          ],
          style: {
            radius: "48"
          }
        }
      },
      {
        icon: "GiftOutlined",
        name: "商品信息",
        type: 'goods',
        selectType: 'drag',
        defaultData: {
          type: 'goods',
          name: '商品模块',
          data: [],
          params: {
            is_show: true,
            is_show_price: true
          }
        }
      },
      {
        icon: "BranchesOutlined",
        name: "溯源模块",
        type: 'traceModule',
        selectType: 'drag',
        defaultData: {
          type: 'traceModule',
          items: [
            {
              type: 'trace',
              name: '溯源信息',
              params: {
                is_show: true,
                is_show_call: false,
                title: "溯源信息",
                showKey: ['fwcode_sn', 'product_name', 'batch_sn', 'server_phone','server_title', 'server_title', 'sale_area', 'video','inspection_report']
              },
              data: [{
                key: 'fwcode_sn',
                label: '溯源编码',
                defaultText: '91440106696938899',
              },
              {
                key: 'product_name',
                label: '产品名称',
                defaultText: '金龙鱼 东北大米 5kg 乳玉皇妃稻香贡米...',
              },
              {
                key: 'batch_sn',
                label: '生产批次',
                defaultText: '001',
              },
              {
                key: 'server_phone',
                label: '服务电话',
                defaultText: ' 13012345678',
              },
              {
                key: 'server_title',
                label: '服务信息',
                defaultText: '华南营销中心',
              },
              {
                key: 'sale_area',
                label: '销售区域',
                defaultText: '广东省/广州市/天河区',
              },
              {
                key: 'inspection_report',
                label: '检验报告'
              },
              {
                key: 'video',
                label: '监控视频直播',
                defaultText: '91440106696938899',
              },
           
            ]
            },
            {
              type: 'enterprise',
              name: '企业信息',
              params: {
                title: "企业信息",
                is_show: true,
                showKey: ['enterpriseInfo', 'company_bar_code', 'company_license_no', 'company_business_addr'],
                is_show_phone: true,
                is_show_call: true,
              },
              data: [{
                key: 'enterpriseInfo',
              },
              {
                key: 'company_bar_code',
                label: '组织机构代码',
                defaultText: '91440106696938899',
              },
              {
                key: 'company_license_no',
                label: '营业执照代码',
                defaultText: '91440106696938899',
              },
              {
                key: 'company_business_addr',
                label: '企业地址',
                defaultText: '广州市天河区棠安路288-298号首 层、二层局部（轴A-J交1-14部位） 广州市天盈',
              }]
            }
          ]
        }
      },
      {
        icon: "RadarChartOutlined",
        name: "防伪信息",
        type: 'antiCounterfeiting',
        selectType: 'drag',
        defaultData: {
          type: 'antiCounterfeiting',
          name: '防伪模块',
          data: [],
          params: {
            antis_fake_tem_title: '',
            antis_fake_tem_id: ''
          }
        }
      },
      // {
      //   icon: "BranchesOutlined",
      //   name: "溯源信息",
      //   type: 'trace',
      //   selectType: 'drag',
      //   defaultData: {
      //     type: 'trace',
      //     name: '溯源信息',
      //     params: {
      //       showKey: ['fwcode_sn', 'product_name', 'batch_sn', 'server_phone', 'server_title', 'sale_area', 'video']
      //     },
      //     data: [{
      //       key: 'fwcode_sn',
      //       label: '溯源编码',
      //       defaultText: '91440106696938899',
      //     },
      //     {
      //       key: 'product_name',
      //       label: '产品名称',
      //       defaultText: '金龙鱼 东北大米 5kg 乳玉皇妃稻香贡米...',
      //     },
      //     {
      //       key: 'batch_sn',
      //       label: '生产批次',
      //       defaultText: '001',
      //     },
      //     {
      //       key: 'server_phone',
      //       label: '服务电话',
      //       defaultText: ' 13012345678',
      //     },
      //     {
      //       key: 'sale_area',
      //       label: '销售区域',
      //       defaultText: '广东省/广州市/天河区',
      //     },
      //     {
      //       key: 'video',
      //       label: '监控视频直播',
      //       defaultText: '91440106696938899',
      //     }]
      //   }
      // },
      // {
      //   icon: "AuditOutlined",
      //   name: "企业信息",
      //   selectType: 'drag',
      //   type: 'enterprise',
      //   defaultData: {
      //     type: 'enterprise',
      //     name: '企业信息',
      //     params: {
      //       showKey: ['enterpriseInfo', 'organization', 'business', 'address']
      //     },
      //     data: [{
      //       key: 'enterpriseInfo',
      //     },
      //     {
      //       key: 'organization',
      //       label: '组织机构代码',
      //       defaultText: '91440106696938899',
      //     },
      //     {
      //       key: 'business',
      //       label: '营业执照代码',
      //       defaultText: '91440106696938899',
      //     },
      //     {
      //       key: 'address',
      //       label: '企业地址',
      //       defaultText: '广州市天河区棠安路288-298号首 层、二层局部（轴A-J交1-14部位） 广州市天盈',
      //     }]
      //   }
      // },
    ],
  },
  {
    title: "高级组件",
    type: "heigh",
    modules: [
      // {
      //   icon: "BorderOutlined",
      //   name: "独占一行",
      //   selectType: 'click',
      //   type: 'layout',
      //   defaultData: {
      //     type: 'layoutLine',
      //     columns: 1,
      //     component: {
      //       //  存储 组件数据
      //       items: [],
      //       //  存储组件标识
      //       components: []
      //     }
      //   }
      // },
      {
        icon: "AppstoreOutlined",
        name: "堆积两列",
        type: 'layout',
        selectType: 'click',
        defaultData: {
          type: 'layoutColumns',
          columns: 2,
          component: {
            //  存储 组件数据
            items: [],
            //  存储组件标识
            components: []
          }
        }
      },
      {
        icon: "DatabaseOutlined",
        name: "堆积三列",
        type: 'layout',
        selectType: 'click',
        defaultData: {
          type: 'layoutThree',
          columns: 3,
          component: {
            //  存储 组件数据
            items: [],
            //  存储组件标识
            components: []
          }
        }
      },
      {
        icon: "DatabaseOutlined",
        name: "堆积四列",
        type: 'layout',
        selectType: 'click',
        defaultData: {
          type: 'layoutFour',
          columns: 4,
          component: {
            //  存储 组件数据
            items: [],
            //  存储组件标识
            components: []
          }
        }
      },
      {
        icon: "InsertRowAboveOutlined",
        name: "tab布局",
        type: 'layout',
        selectType: 'click',
        defaultData: {
          type: 'layoutTabs',
          columns: 'tabs',
          component: {
            //  存储 组件数据
            items: [],
            //  存储组件标识
            components: []
          }
        }
      },
    ]
  },
]
